import React, { Component, useState, useEffect } from "react";

import { Row, Col, Card, CardBody, FormGroup, Button, Label, Input, Container, InputGroup, Form, InputGroupAddon } from "reactstrap";
import { AvForm } from "availity-reactstrap-validation";

import { Modal } from 'react-bootstrap';

// import the redux
import { useSelector, useDispatch } from 'react-redux'

import {
    BsFillCursorFill,
    BsBarChartSteps,
    BsPlusCircleFill,
    BsFillCalendarCheckFill,
    BsFillPersonCheckFill,
    BsFillRecord2Fill,
    BsReverseLayoutTextSidebarReverse,
    BsFillStopCircleFill,
    BsFillPencilFill,
} from "react-icons/bs";
import { changeStatus, updateCertificationDataJson, updateDataJson } from "../../store/actions";

// import the components bootstrap
import { Button as B, Modal as M } from 'react-bootstrap';

// import the component public sector
import PublicSector from "./PublicSector";

import PublicSectorAdmin from "./AdminViews/PublicSectorAdmin";

// import the component private sector
import PrivateSector from "./PrivateSector";

import PrivateSectorAdmin from "./AdminViews/PrivateSectorAdmin";

// import the supply component
import Supply from "./Supply";

import SupplyAdmin from "./AdminViews/SupplyAdmin";

// import the teams component
import Teams from "./Teams";

// import the special component 
import Specials from "./Specials";

// import the supply part component
import ListSupplies from './ListSupplies';

// import the select sector component 
import SelectSector from "./SelectSector";

import SelectSectorChannel from "./SelectSectorChannel";

// import the admin select sector component
import SelectSectorAdmin from "./AdminViews/SelectSectorAdmin";

// import the component Certificate Supplies
import CertificadoSupplies from "../../components/CertificadoSupplies";

import ListSuppliesAdmin from "./AdminViews/ListSuppliesAdmin";

import useHttp from "../../hook/use-http";

// import the style of the component
import './style.css'
import { toast } from "react-toastify";

/* This array represent different provider */
const providers = [
    { id: 2, name: "TECNOMEGA" },
    { id: 3, name: "MEGAMICRO" },
];

/* This array represent the list of type of channel */

const typesChannel = [
    { id: 1, name: "TRADICIONAL" },
    { id: 2, name: "CONNECT" },
]


// this variable will be used to control the type of the request
// this value will get in the param
let typeSolicitation = 'SUMINISTROS'

const CreateSupplyCertificate = ({ match, history }) => {

    // this variable will be used to control the type of the request
    // this function will be used to request the server to login the user
    const { loading, error, request: requestUrl } = useHttp();

    const [codeRequest, setCodeRequest] = useState(match.params.code);

    // this variable will be control the amount of component supplies list
    const [listsComponent, setListsComponent] = useState();
    // this variable will be control the id of the component supplies list
    const [amountListSuppliesId, setAmountListSuppliesId] = useState(0)

    // this variable will be used to control which view private or public
    const [isPublic, setIsPublic] = useState(true)
    const handleChangeView = (e) => setIsPublic(e)

    // this variable represent the date of the request
    const [dateRequest, setDateRequest] = useState('')

    // get the data with redux dispatch
    const dispatch = useDispatch()
    const dataJson = useSelector(state => state.CertificationJsonConsume.data)

    // this variable will be used to set the channel selected
    const [request, setRequest] = useState([])

    // this variable will control the if the admin can change the channel or no
    const [disabled, setDisabled] = useState(true)

    // this variable will be used to save the certification selected
    const [certifications, setCertifications] = useState([])

    // this will be used to control de component modal  
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    // this variable will be used to get information of the channel
    const profile = useSelector(state => state.profileReducer.profile)

    /*********************************************************************** */
    /*********************************************************************** */
    /**  DECLARE THE VARIABLE USED TO CONTROL THE VIEW OF THE USER ***********/

    const [isAdmin, setIsAdmin] = useState(false)

    /*********************************************************************** */
    /*********************************************************************** */

    const [reasonRejection, setReasonRejection] = useState('')

    /***************************************************************/
    /***************************************************************/
    /**  declare state variables to approve or reject a request  ***/
    /***************************************************************/
    /***************************************************************/

    // this variable represent the comment if the request is reject
    const [observaciones, setObservaciones] = useState('')

    // this variable represent the status of the request
    const [statusRequest, setStatusRequest] = useState(null)

    // this variable represent the array of the supplies list part number
    const [partListSupplies, setPartListSupplies] = useState([])

    // this function will be used to process the request of getChannelProfile
    const getChannelProfileDataRequest = (e) => {

        if (!e.status) {
            // set the header of the request
            // add a extra field to the header
            setRequest(prov => {
                return {
                    ...prov,
                    razon_social: e.razonSocial,
                    ruc: e.ruc,
                    mayorista: e.mayorista
                }
            })
        }
    }
    // this function will be used to get the profile of the channel
    const getChannelProfileAdmin = (ruc) => {

        try {
            // set the header of the request
            const myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            myHeaders.append("Authorization", "Bearer " + localStorage.getItem('token'));

            requestUrl({
                // i need to get the url of the request
                url: `/auth/channel/list/ruc/` + ruc,
                method: 'GET',
                headers: myHeaders,
            }, getChannelProfileDataRequest)

        } catch (err) {
            console.log(err)
        }

    }

    // this function will be used to process the request of getDataOfCodeRequest
    const getDataOfCodeRequestDataResponse = (response) => {
        if (!response.status) {
            // set information of the request 
            setRequest(prov => {
                return {
                    ...prov,
                    estado: response.estado,
                    mayorista: response.mayorista,
                    RUC: response.ruc,
                    estado: response.estado,
                    requerimiento: response.requerimentoEspecifico,
                    suministros: response.suministros,
                    sector: response.sector,
                    dataProcess: response.datosSectorPrivado || response.datosSectorPublico,
                    certificados: response.certificados,
                    motivoRechazo: response.motivoRechazo
                }
            })

            // In the case i will change the sector of the request
            if (response.sector === "PRIVADO") {
                setIsPublic(false)
            } else {
                setIsPublic(true)
            }

            getChannelProfileAdmin(response.ruc)

        }
    }

    // this function will be get the data of the code of the request
    const getDataOfCodeRequest = (code) => {

        try {
            // set the header of the request
            const myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            myHeaders.append("Authorization", "Bearer " + localStorage.getItem('token'));

            requestUrl({
                // i need to get the url of the request
                url: `/auth/solicitud/list/` + code,
                method: 'GET',
                headers: myHeaders,
            }, getDataOfCodeRequestDataResponse)

        } catch (err) {
            console.log(err)
        }
    }

    useEffect(() => {
        // this variable will be used to get the id of the channel
        const { code } = match.params
        console.log(match.params)
        if (code) {
            setCodeRequest(code)
            getDataOfCodeRequest(code);
        } /*else {

            // this variable will save the channel selected
            const resultSelected = dataJson[0]

            // set the channel selected
            setRequest(resultSelected)
        }
        */


        // here i need to calculate the time of the request
        let d = new Date
        let dformat = [d.getMonth() + 1,
        d.getDate(),
        d.getFullYear()].join('/') + ' ' +
            [d.getHours(),
            d.getMinutes(),
            d.getSeconds()].join(':');

        setDateRequest(dformat)

        const role = localStorage.getItem('role')

        if (role == 'ROLE_CHANNEL') {
            setIsAdmin(false)
        } else {
            setIsAdmin(true)
        }

    }, [])

    // this function will be used when the request is reject
    const onHandleRejectOrApproveRequest = (status) => {

        const { id = 0 } = match.params;
        const observation = observaciones

        dispatch(updateCertificationDataJson(
            id,
            status,
            observation
        ), {
            type: 'UPDATE_DATA_JSON'
        })

        // close the modal
        handleClose()

        // redirect to list requests
        history.push('/approval-request-list')
    }

    // this function will be used to add a new part supply into list supplies
    const addSupplyIntoListSupplies = (supply) => {
        setPartListSupplies((prov) => {
            return [
                ...prov,
                supply
            ]
        })
    }

    // this function will be used to add certification into list teams 
    const addCertificationIntoListTeams = (certification) => {
        setCertifications(prov => {
            return [...prov, certification]
        })
    }

    // this function will be used to remove certification into list teams
    const removeCertificationIntoListTeams = (certification) => {
        const index = certifications.indexOf(certification)
        setCertifications(prov => {
            return prov.filter((item, i) => i !== index)
        });
    }

    // rendered the certification selected
    const renderCertificationTeams = Object.values(certifications).map((item, index) => {
        return (
            <div key={index + 100}>
                {item.name_component}
            </div>
        )
    });

    const addNewComponentSupply = () => {
        const id = amountListSuppliesId + "_supply_id";
        setListsComponent((prov) => (
            <div id={id}>
                < ListSupplies
                    addSupplyIntoListSupplies={addSupplyIntoListSupplies}
                    id={id}
                />
                {prov}
            </div>
        ));
        setAmountListSuppliesId(prov => {
            return prov + 1;
        })
    }


    // redirect to list requests
    const handleRedirect = () => {
        history.push('/consult-request-channel')
    }

    /************************************************************************** */
    /************************************************************************** */

    // this function will be used to save all item of the list supplies
    const [listSuppliesSelected, setListSuppliesSelected] = useState([])
    // this function contain the list of certificated selected
    const [listCertificatedSelected, setListCertificatedSelected] = useState([])
    // this function will be used to save the data of the process
    const [dataProcess, setDataProcess] = useState({})

    const handleChangeListSuppliesSelected = (e) => {
        console.log(e)
        setListSuppliesSelected(e)
    }

    const handleChangeListCertificatedSelected = (e) => {
        setListCertificatedSelected(e)
    }

    const handleChangeDataProcess = (e) => {
        setDataProcess(e)
        console.log(e)
    }

    /************************************************************************** */
    /************************************************************************** */

    const generateElementErrorInInput = (name) => {
        const element = document.getElementById(name);
        element.classList.remove('is-untouched');
        element.classList.add('is-touched');
        element.classList.add('is-invalid');
    }

    const validateDataProcessSectorPrivate = () => {
        let isValid = true;

        if (document.getElementById('nombre_empresa').value.trim().length === 0) {
            generateElementErrorInInput('nombre_empresa');
            toast('Por favor ingresar el nombre de la empresa ', { type: 'error', autoClose: 10000 });
            isValid = false;
        }

        if (document.getElementById('dirigido').value.trim().length === 0) {
            generateElementErrorInInput('dirigido');
            toast('Por favor ingresar a quien va dirigido ', { type: 'error', autoClose: 10000 });
            isValid = false;
        }

        if (document.getElementById('cargo').value.trim().length === 0) {
            generateElementErrorInInput('cargo');
            toast('Por favor ingresar el cargo', { type: 'error', autoClose: 10000 });
            isValid = false;
        }

        return isValid;

    }

    const validateDataProcessSectorPublic = () => {
        let isValid = true;

        if (document.getElementById('entidad_contratante').value.trim().length === 0) {
            generateElementErrorInInput('entidad_contratante');
            toast('Por favor ingresar la entidad contrante', { type: 'error', autoClose: 10000 });
            isValid = false;
        }

        if (document.getElementById('email_encargado').value.trim().length === 0) {
            generateElementErrorInInput('email_encargado');
            toast('Por favor ingresar el email del encargado', { type: 'error', autoClose: 10000 });
            isValid = false;
        }

        if (document.getElementById('objecto_proceso').value.trim().length === 0) {
            generateElementErrorInInput('objecto_proceso');
            toast('Por favor ingresar el objeto del proceso', { type: 'error', autoClose: 10000 });
            isValid = false;
        }

        if (document.getElementById('codigo_proceso').value.trim().length === 0) {
            generateElementErrorInInput('codigo_proceso');
            toast('Por favor ingresar el código del proceso', { type: 'error', autoClose: 10000 });
            isValid = false;
        }

        if (document.getElementById('fecha_limite_preguntas').value.trim().length === 0) {
            generateElementErrorInInput('fecha_limite_preguntas');
            toast('Por favor ingresar la fecha limite de preguntas', { type: 'error', autoClose: 10000 });
            isValid = false;
        }

        if (document.getElementById('fecha_limite_respuesta').value.trim().length === 0) {
            generateElementErrorInInput('fecha_limite_respuesta');
            toast('Por favor ingresar la fecha limite de respuesta', { type: 'error', autoClose: 10000 });
            isValid = false;
        }

        if (document.getElementById('fecha_limite_entrega_oferta').value.trim().length === 0) {
            generateElementErrorInInput('fecha_limite_entrega_oferta');
            toast('Por favor ingresar la fecha limite de entrega de oferta', { type: 'error', autoClose: 10000 });
            isValid = false;
        }

        if (document.getElementById('fecha_limite_calificacion').value.trim().length === 0) {
            generateElementErrorInInput('fecha_limite_calificacion');
            toast('Por favor ingresar la fecha limite de calificación', { type: 'error', autoClose: 10000 });
            isValid = false;
        }

        if (document.getElementById('fecha_inicio_puja').value.trim().length === 0) {
            generateElementErrorInInput('fecha_inicio_puja');
            toast('Por favor ingresar la fecha de inicio de puja', { type: 'error', autoClose: 10000 });
            isValid = false;
        }

        if (document.getElementById('plazo_entrega').value.trim().length === 0) {
            generateElementErrorInInput('plazo_entrega');
            toast('Por favor ingresar el plazo de entrega', { type: 'error', autoClose: 10000 });
            isValid = false;
        }

        return isValid;
    }

    const validateDataProcess = () => {
        if (isPublic) {
            return validateDataProcessSectorPublic()
        } else {
            return validateDataProcessSectorPrivate()
        }
    }

    const validateCertificatedSelected = () => {
        let isValid = true;
        if (listCertificatedSelected.length === 0) {
            toast('Por favor seleccionar al menos un certificado', { type: 'error', autoClose: 10000 });
            isValid = false;
        }
        return isValid;
    }

    const validateSuppliesSelected = () => {
        let isValid = true;
        if (listSuppliesSelected.length === 0) {
            toast('Por favor seleccionar al menos un suministro', { type: 'error', autoClose: 10000 });
            isValid = false;
        }
        return isValid;
    }

    const sendRequestSupplyDataResponse = (response) => {
        if (response.status) {
            // show a error message here
            if (response.errorCode === 12) {
                localStorage.removeItem('token')
                localStorage.removeItem('user')
                localStorage.removeItem('email')
                localStorage.removeItem('role')
                history.push('/login')
            }

            toast(response.message, { type: 'error', autoClose: 10000 });
        } else {
            history.push('/request-sended')

        }
    }

    const sendRequestSupply = () => {

        const certificados = []
        listCertificatedSelected.forEach(item => {
            certificados.push(item.code)
        })

        try {

            if (validateDataProcess() && validateCertificatedSelected() && validateSuppliesSelected()) {

                // set the header of the request
                const myHeaders = new Headers();
                myHeaders.append("Content-Type", "application/json");
                myHeaders.append("Authorization", "Bearer " + localStorage.getItem('token'));

                const sector = isPublic ? 'PUBLICO' : 'PRIVADO'
                // this variable will be save which certification send to the backend
                const certificados = []
                listCertificatedSelected.forEach(item => {
                    certificados.push(item.code)
                })

                
                if (isPublic) {

                    requestUrl({
                        // i need to get the url of the request
                        url: '/auth/solicitud/register/suministro',
                        method: 'POST',
                        headers: myHeaders,
                        body: {
                            "ruc": profile.ruc,
                            "descripcion": profile.razonSocial,
                            "tipo": "SUMINISTRO",
                            "mayorista": dataProcess.proveedor,
                            "sector": sector,
                            "datosSectorPublico": dataProcess,
                            "suministros": listSuppliesSelected,
                            "certificados": certificados
                        }
                    }, sendRequestSupplyDataResponse)

                } else {
                    requestUrl({
                        // i need to get the url of the request
                        url: '/auth/solicitud/register/suministro',
                        method: 'POST',
                        headers: myHeaders,
                        body: {
                            "ruc": profile.ruc,
                            "descripcion": profile.razonSocial,
                            "tipo": "SUMINISTRO",
                            "mayorista": dataProcess.proveedor,
                            "sector": sector,
                            "datosSectorPrivado": dataProcess,
                            "suministros": listSuppliesSelected,
                            "certificados": certificados
                        }
                    }, sendRequestSupplyDataResponse)
                }
            }


        } catch (er) {
            console.log(er)
        }

        console.log(listCertificatedSelected)
        console.log(listSuppliesSelected)
        console.log(certificados)
    }


    const sendEdithRequestSupplyDataResponse = (response) => {
        if (response.status) {
            // show a error message here
            if (response.errorCode === 12) {
                localStorage.removeItem('token')
                localStorage.removeItem('user')
                localStorage.removeItem('email')
                localStorage.removeItem('role')
                history.push('/login')
            }

            toast(response.message, { type: 'error', autoClose: 10000 });
        } else {
            history.push('/request-sended')
        }
    }



    const sendEdithRequestSupply = () => {
        const certificados = []
        listCertificatedSelected.forEach(item => {
            certificados.push(item.code)
        })

        try {

            if (validateDataProcess() && validateCertificatedSelected() && validateSuppliesSelected()) {

                const { code } = match.params

                // set the header of the request
                const myHeaders = new Headers();
                myHeaders.append("Content-Type", "application/json");
                myHeaders.append("Authorization", "Bearer " + localStorage.getItem('token'));

                const sector = isPublic ? 'PUBLICO' : 'PRIVADO'
                // this variable will be save which certification send to the backend
                const certificados = []
                listCertificatedSelected.forEach(item => {
                    certificados.push(item.code)
                })

                if (isPublic) {

                    requestUrl({
                        // i need to get the url of the request
                        url: '/auth/solicitud/edit/suministro',
                        method: 'PUT',
                        headers: myHeaders,
                        body: {
                            "codigo": code,
                            "ruc": profile.ruc,
                            "descripcion": profile.razonSocial,
                            "tipo": "SUMINISTRO",
                            "mayorista": profile.mayorista,
                            "sector": sector,
                            "datosSectorPublico": dataProcess,
                            "suministros": listSuppliesSelected,
                            "certificados": certificados
                        }
                    }, sendEdithRequestSupplyDataResponse)

                } else {
                    requestUrl({
                        // i need to get the url of the request
                        url: '/auth/solicitud/edit/suministro',
                        method: 'PUT',
                        headers: myHeaders,
                        body: {
                            "codigo": code,
                            "ruc": profile.ruc,
                            "descripcion": profile.razonSocial,
                            "tipo": "SUMINISTRO",
                            "mayorista": profile.mayorista,
                            "sector": sector,
                            "datosSectorPrivado": dataProcess,
                            "suministros": listSuppliesSelected,
                            "certificados": certificados
                        }
                    }, sendEdithRequestSupplyDataResponse)
                }
            }

        } catch (er) {
            console.log(er)
        }
    }

    const approveRequestAdminFunctionDataResponse = (response) => {
        history.push('/request-approved')
    }

    const approveRequestAdminFunction = () => {
        try {

            const { code } = match.params

            // set the header of the request
            const myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            myHeaders.append("Authorization", "Bearer " + localStorage.getItem('token'));

            requestUrl({
                // i need to get the url of the request
                url: '/auth/solicitud/aprobar',
                method: 'POST',
                headers: myHeaders,
                body: {
                    "codigoSolicitud": code
                }
            }, approveRequestAdminFunctionDataResponse)

        } catch (er) {
            console.log(er)
        }
    }

    const denyRequestAdminFunctionDataResponse = () => {
        history.push('/request-rejected')
    }

    const denyRequestAdminFunction = () => {
        try {

            const { code } = match.params

            // set the header of the request
            const myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            myHeaders.append("Authorization", "Bearer " + localStorage.getItem('token'));

            requestUrl({
                // i need to get the url of the request
                url: '/auth/solicitud/rechazar',
                method: 'POST',
                headers: myHeaders,
                body: {
                    "codigoSolicitud": code,
                    "motivoRechazo": reasonRejection
                }
            }, denyRequestAdminFunctionDataResponse)

        } catch (er) {
            console.log(er)
        }
    }

    return (
        <React.Fragment>
            {request && (

                <div className="page-content">
                    <Container fluid={true}>

                        <Row style={{ display: 'flex', justifyContent: 'flex-start' }}>

                            <h1 className="form-label mb-3"
                                style={{ fontWeight: 'bold' }}
                            >
                                SOLICITAR CERTIFICADO {typeSolicitation.toUpperCase()}
                            </h1>

                            {request.motivoRechazo && (
                                <div>
                                    <div className=" alert alert-danger" role="alert">
                                        <span style={{ color: 'red', fontWeight: 'bold' }}>SOLICITUD RECHAZADO:</span>  {request.motivoRechazo}
                                    </div>
                                </div>
                            )}

                            <Col xl="12" style={{ width: '100%' }} id="datos" >
                                <Card style={{ height: '100%' }} >
                                    <CardBody>

                                        <AvForm className="needs-validation" >
                                            <Row className="d-flex justify-content-center ">
                                                <Col xl="3" className="d-flex flex-column justify-content-around" >
                                                    <div style={{ marginBottom: 10 }} >

                                                        <div>
                                                            <h6 style={{ fontWeight: 'bold' }}>
                                                                CANAL
                                                            </h6>
                                                        </div>

                                                        <div className="d-flex align-items-center">
                                                            <i style={{ fontSize: 30, marginRight: 10 }}>
                                                                <BsFillCursorFill />
                                                            </i>
                                                            <h6 style={{ margin: 0 }}>
                                                                {request.razon_social ? request.razon_social : profile.razonSocial}
                                                            </h6>
                                                        </div>
                                                    </div>
                                                    <Col xl="4" className="d-flex flex-column justify-content-end">
                                                        <div style={{ marginBottom: 10 }}>
                                                            <div>
                                                                <h6 style={{ fontWeight: 'bold' }}>
                                                                    RUC
                                                                </h6>
                                                            </div>

                                                            <div className="d-flex align-items-center">
                                                                <i style={{ fontSize: 30, marginRight: 10 }}>
                                                                    <BsReverseLayoutTextSidebarReverse />
                                                                </i>
                                                                <h6 style={{ margin: 0 }}>
                                                                    {request.ruc ? request.ruc : profile.ruc}
                                                                </h6>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                </Col>

                                                <Col xl="3" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>

                                                    <div className="d-flex flex-column justify-content-center " style={{ marginBottom: 10 }}>
                                                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                                                            <h6 style={{ fontWeight: 'bold' }}>
                                                                TIPO DE CERTIFICADO
                                                            </h6>
                                                        </div>

                                                        <div className="d-flex align-items-center" style={{ justifyContent: 'center' }}>
                                                            <i style={{ fontSize: 30, marginRight: 10 }}>
                                                                <BsBarChartSteps />
                                                            </i>
                                                            <h6 style={{ margin: 0 }}>
                                                                {typeSolicitation.toUpperCase()}
                                                            </h6>
                                                        </div>
                                                    </div>

                                                    <div className="d-flex flex-column justify-content-center ">
                                                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                                                            <h6 style={{ fontWeight: 'bold' }}>
                                                                FECHA SOLICITUD
                                                            </h6>
                                                        </div>
                                                        <div className="d-flex align-items-center" style={{ justifyContent: 'center' }}>
                                                            <i style={{ fontSize: 30, marginRight: 10 }}>
                                                                <BsFillCalendarCheckFill />
                                                            </i>
                                                            <h6 style={{ margin: 0 }}>
                                                                {dateRequest}
                                                            </h6>
                                                        </div>
                                                    </div>
                                                </Col>

                                                <Col xl="3" style={{ display: 'flex', flexDirection: 'column' }} >

                                                    <div className="d-flex flex-column justify-content-center ">

                                                        <div className="d-flex align-items-center" style={{ justifyContent: 'end' }}>
                                                            <h6 style={{ fontWeight: 'bold' }}>
                                                                ESTADO
                                                            </h6>
                                                        </div>
                                                        <div className="d-flex align-items-center" style={{ justifyContent: 'end' }}>
                                                            <i style={{ fontSize: 30, marginRight: 10 }}>
                                                                <BsFillPencilFill style={{ color: '#FFDB58', fontWeight: 'bold' }} />
                                                            </i>
                                                            <h6 style={{
                                                                margin: 0, fontWeight: 'bold', color: '#FFDB58', //WebkitTextStroke: '.5px black'
                                                            }}>
                                                                EDITANDO
                                                            </h6>
                                                        </div>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </AvForm>
                                    </CardBody>
                                </Card>
                            </Col>

                            <Col xl="12" style={{ width: '100%', marginTop: 20 }} id="datos" >
                                <Card style={{ height: '100%' }} >
                                    <CardBody>
                                        <AvForm className="needs-validation" >
                                            <Row >
                                                <Col xl="12" >
                                                    {isAdmin && request.sector ? (
                                                        <SelectSectorAdmin handleChangeView={handleChangeView} sector={request.sector} />
                                                    ) : !isAdmin && (request.estado === 'RECHAZADO') ? (
                                                        <SelectSector handleChangeView={handleChangeView} sector={request.sector ? request.sector : ''} />
                                                    ) : request.sector ? (
                                                        <SelectSectorAdmin handleChangeView={handleChangeView} sector={request.sector} />
                                                    ) : !request.sector ? (
                                                        <SelectSectorChannel handleChangeView={handleChangeView} />
                                                    ) : ''}
                                                </Col>
                                            </Row>
                                        </AvForm>
                                    </CardBody>
                                </Card>
                            </Col>

                            <Row style={{ paddingRight: 0 }}>

                                {/* SHOW THE PUBLIC SESCTOR */}
                                <Col xl="12" style={{ width: '70%', marginTop: 20 }} id="certificados" >
                                    <Card style={{ height: '100%' }}>
                                        <CardBody style={{ display: 'flex', flexDirection: 'column' }}>
                                            {isPublic && !isAdmin && (request.estado === 'RECHAZADO' || !request.estado) ? (
                                                < PublicSector
                                                    handleChangeDataProcess={handleChangeDataProcess}
                                                    dataProcess={request.dataProcess ? request.dataProcess : ''}
                                                />

                                            ) : !isAdmin && (request.estado === 'RECHAZADO' || !request.estado) ? (
                                                <PrivateSector
                                                    handleChangeDataProcess={handleChangeDataProcess}
                                                    dataProcess={request.dataProcess ? request.dataProcess : ''}
                                                />
                                            ) : isPublic && !isAdmin ? (
                                                < PublicSectorAdmin
                                                    handleChangeDataProcess={handleChangeDataProcess}
                                                    dataProcess={request.dataProcess}
                                                />
                                            ) : !isPublic && !isAdmin ? (
                                                < PrivateSectorAdmin
                                                    handleChangeDataProcess={handleChangeDataProcess}
                                                    dataProcess={request.dataProcess}
                                                />
                                            ) : ''}

                                            {isAdmin && (request.sector === 'PRIVADO') ? (
                                                < PrivateSectorAdmin
                                                    handleChangeDataProcess={handleChangeDataProcess}
                                                    dataProcess={request.dataProcess}
                                                />
                                            ) : isAdmin && (request.sector === 'PUBLICO') ? (
                                                < PublicSectorAdmin
                                                    handleChangeDataProcess={handleChangeDataProcess}
                                                    dataProcess={request.dataProcess}
                                                />
                                            ) : ''}
                                        </CardBody>
                                    </Card>
                                </Col>

                                {/* DATOS DEL PROCESO - SECTOR PUBLICO O PRIVADO */}
                                <Col xl="12" style={{ width: '30%', marginTop: 20, padding: 0 }} id="datos_proceso" >
                                    <Card style={{ height: '100%' }}>
                                        <CardBody style={{ height: '100%' }}>
                                            {isAdmin && request.certificados ? (
                                                < SupplyAdmin
                                                    handleChangeListCertificatedSelected={handleChangeListCertificatedSelected}
                                                    certificationSelected={request.certificados}
                                                    estado={request.estado ? request.estado : ''}
                                                    codeRequest={codeRequest ? codeRequest : ''}
                                                />
                                            ) : !isAdmin && (request.estado === 'RECHAZADO' || !request.estado) ? (

                                                < Supply
                                                    handleChangeListCertificatedSelected={handleChangeListCertificatedSelected}
                                                    certificationSelected={request.certificados ? request.certificados : []}
                                                    estado={request.estado ? request.estado : ''}
                                                    codeRequest={codeRequest ? codeRequest : ''}
                                                />
                                            ) : !isAdmin ? (
                                                < SupplyAdmin
                                                    handleChangeListCertificatedSelected={handleChangeListCertificatedSelected}
                                                    certificationSelected={request.certificados}
                                                    estado={request.estado ? request.estado : ''}
                                                    codeRequest={codeRequest ? codeRequest : ''}
                                                />
                                            ) : ''}
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>

                            {isAdmin && (request.suministros) ? (
                                < ListSuppliesAdmin
                                    title="LISTA DE SUMINISTROS"
                                    handleChangeListSuppliesSelected={handleChangeListSuppliesSelected}
                                    suministros={request.suministros} />
                            ) : !isAdmin && (request.estado === 'RECHAZADO' || !request.estado) ? (
                                < CertificadoSupplies
                                    title="LISTA DE SUMINISTROS"
                                    handleChangeListSuppliesSelected={handleChangeListSuppliesSelected}
                                    suministros={request.suministros ? request.suministros : []}
                                />
                            ) : !isAdmin ? (
                                < ListSuppliesAdmin
                                    title="LISTA DE SUMINISTROS"
                                    handleChangeListSuppliesSelected={handleChangeListSuppliesSelected}
                                    suministros={request.suministros} />
                            ) : ''}

                        </Row>
                        {isAdmin ? (
                            <>
                                <div className="d-flex justify-content-end mt-3">
                                    <div className="mx-3">
                                        <button
                                            className="btn btn-danger-lexmark mx-2"
                                            type="button"
                                            onClick={handleShow}
                                        >RECHAZAR</button>
                                        <button
                                            className="btn btn-primary-lexmark"
                                            type="button"
                                            onClick={approveRequestAdminFunction}
                                        >APROBAR</button>
                                    </div>
                                </div>
                            </>
                        ) : !isAdmin && request.estado === 'RECHAZADO' ? (
                            <div className="d-flex justify-content-end mt-3">
                                <div className="mx-3">
                                    <button
                                        className="btn btn-primary-lexmark"
                                        type="button"
                                        onClick={sendEdithRequestSupply}
                                    >RENVIAR SOLICITUD</button>
                                </div>
                            </div>
                        ) : !isAdmin && !request.estado ? (
                            <div className="d-flex justify-content-end mt-3">
                                <div className="mx-3">
                                    <button
                                        className="btn btn-primary-lexmark"
                                        type="button"
                                        onClick={sendRequestSupply}
                                        disabled={loading}
                                    >
                                        SOLICITAR
                                        
                                    </button>
                                </div>
                            </div>
                        ) : ''}
                    </Container>
                </div>
            )}

            <Modal
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header closeButton>
                    <Modal.Title>RECHAZAR SOLICITUD</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>
                        Por favor ingrese el motivo por la cual rechazará la solicitud.
                    </p>
                    <input
                        type="text"
                        className="form-control"
                        value={reasonRejection}
                        onChange={(e) => setReasonRejection(e.target.value)}
                    />
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-secondary" onClick={handleClose}>
                        CERRAR
                    </button>
                    <Button className="btn btn-danger" onClick={denyRequestAdminFunction}>RECHAZAR</Button>
                </Modal.Footer>
            </Modal>
        </React.Fragment >
    );

}

export default CreateSupplyCertificate;
